import { render, staticRenderFns } from "./failed_job_details.vue?vue&type=template&id=2d80698e"
import script from "./failed_job_details.vue?vue&type=script&lang=js"
export * from "./failed_job_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports